/* eslint-disable import/no-unresolved */
import Page from 'src/components/Page';
import { Card, Container, Typography, Button, Stack, Box, Icon } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import { useTheme } from '@material-ui/styles';
// import fill from '@iconify/icons-ant-design/correc';
import { useState } from 'react';

export default function Processing({ handleClose, data, handleContinue }) {
  const { themeStretch } = useSettings();
  const theme = useTheme();
  const [btnName, setBtnName] = useState(true);

  return (
    <Page title="Collection Data | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Card sx={{ p: 3 }}>
          <Stack spacing={3}>
            <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
              {!data?.apply_rule && (
                <Typography color="darkred" sx={{ fontWeight: 'bold' }} align="center">
                  Required headers is not present in your file.
                </Typography>
              )}
              <Typography sx={{ fontWeight: 'bold' }} align="center">
                Please Wait.....{' '}
              </Typography>
              <Box sx={{ display: 'flex' }}>
                <Typography sx={{ fontWeight: 'bold', marginRight: '1rem' }}>Checking Required Headers : </Typography>
                <Typography variant="subtitle1" color="primary">
                  {data?.required_column_no} out of {data?.available_column_no}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <Typography sx={{ fontWeight: 'bold', marginRight: '1rem' }}>No. of entries: </Typography>
                <Typography variant="subtitle1" color="primary">
                  {data?.total_entries}
                </Typography>
              </Box>
              {data?.apply_rule && (
                <>
                  <Box sx={{ display: 'flex' }}>
                    <Typography sx={{ fontWeight: 'bold', marginRight: '1rem' }}>Data Inconsistent : </Typography>
                    <Typography variant="subtitle1" color="primary">
                      {data?.inconsistant_data === 0 ? 'No Data' : data?.inconsistant_data}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: 'bold', marginRight: '1rem' }}>Inconsistent Row no. : </Typography>
                    <Box sx={{ padding: '5px', borderBottom: `1px solid ${theme.palette.primary.main}` }}>
                      <Typography color="gray" variant="subtitle1">
                        {data?.inconsistant_row_no?.length > 0 &&
                          data?.inconsistant_row_no?.slice(0, 5)?.map((a, i) => <span key={i}>{a}, </span>)}
                      </Typography>
                    </Box>
                    <Button
                      onClick={() => {
                        navigator.clipboard.writeText(data?.inconsistant_row_no || '');
                        setBtnName(false);
                      }}
                      sx={{ marginLeft: '1rem' }}
                      type="button"
                      variant="outlined"
                      disabled={!btnName}
                    >
                      {btnName ? 'Copy' : 'Copied'}
                    </Button>
                  </Box>
                </>
              )}
              {!data?.apply_rule && data?.missing_columns?.length > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography sx={{ fontWeight: 'bold', marginRight: '1rem' }}>Missing Headers : </Typography>
                  <Typography variant="subtitle1" color="primary">
                    {data?.missing_columns?.map((a) => `${a}, `)}
                  </Typography>
                </Box>
              )}
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                {data?.apply_rule ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleContinue();
                    }}
                  >
                    {' '}
                    Continue
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    {' '}
                    Cancel
                  </Button>
                )}
              </Box>
            </Stack>
          </Stack>
        </Card>
      </Container>
    </Page>
  );
}
